module.exports = "/img/_/_/_/assets/images/creeper/book/common//9.jpg?a0341fb3c7e3a4e3a8249400b9329e5c";